import flexPortfolioApiCall from './flexPortfolio'

const ApiCall = {
  flexPortfolio: flexPortfolioApiCall
}

export default ApiCall
